export default __webpack_public_path__ + "assets/icons/invalid.7a1a2096.svg";